<div class="p-6 max-w-7xl mx-auto">

  <!-- Header -->
  <div class="flex items-center justify-between mb-6">
    <div>
      <h1 class="text-2xl font-bold text-gray-800">Procesos masivos</h1>
      <p class="text-sm text-gray-500">Monitoreo y trazabilidad de ejecuciones masivas (mora, fees, cron jobs)</p>
    </div>
    <button (click)="reload()" [disabled]="loading"
            class="px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white rounded-lg text-sm font-medium">
      <i class="fas fa-sync-alt mr-1" [class.fa-spin]="loading"></i>
      Refrescar
    </button>
  </div>

  <!-- Catálogo colapsable: por defecto oculto. Sólo info — las corridas aparecen
       automáticamente en la tabla cuando se disparan (cron, change stream, etc.) -->
  <div class="mb-4">
    <button (click)="showCatalog = !showCatalog"
            class="text-xs text-gray-500 hover:text-gray-700 flex items-center gap-1">
      <i class="fas" [class.fa-chevron-right]="!showCatalog" [class.fa-chevron-down]="showCatalog"></i>
      {{ showCatalog ? 'Ocultar' : 'Ver' }} catálogo de jobs ({{ jobs.length }})
    </button>
    <div *ngIf="showCatalog" class="mt-2 bg-white border border-gray-200 rounded-lg divide-y divide-gray-100 text-sm">
      <div *ngFor="let job of jobs" class="px-3 py-2 flex items-center justify-between hover:bg-gray-50">
        <div class="flex-1">
          <span class="text-gray-800">{{ job.label }}</span>
          <span class="text-xs text-gray-400 ml-2">{{ job.project }} · {{ job.job_key }}</span>
        </div>
        <span class="px-2 py-0.5 text-xs rounded-full bg-gray-100 text-gray-600 mr-3">{{ job.category }}</span>
        <button (click)="triggerJob(job)"
                [disabled]="!job.manual_trigger_url || triggering === job.job_key"
                title="Ejecutar ahora"
                class="px-3 py-1 text-xs bg-green-600 hover:bg-green-700 disabled:opacity-40 disabled:cursor-not-allowed text-white rounded">
          <i class="fas fa-play mr-1" *ngIf="triggering !== job.job_key"></i>
          <i class="fas fa-spinner fa-spin mr-1" *ngIf="triggering === job.job_key"></i>
          {{ triggering === job.job_key ? 'Disparando...' : 'Ejecutar' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Filtros -->
  <div class="bg-white border border-gray-200 rounded-lg p-4 mb-4">
    <!-- Date preset chips -->
    <div class="flex gap-2 mb-3 items-center flex-wrap">
      <span class="text-xs text-gray-500 mr-2">Período:</span>
      <button (click)="setDatePreset('hoy')"
              [class.bg-blue-600]="datePreset === 'hoy'"
              [class.text-white]="datePreset === 'hoy'"
              [class.bg-gray-100]="datePreset !== 'hoy'"
              [class.text-gray-700]="datePreset !== 'hoy'"
              class="px-3 py-1 rounded text-xs font-medium hover:bg-blue-500 hover:text-white transition">Hoy</button>
      <button (click)="setDatePreset('ayer')"
              [class.bg-blue-600]="datePreset === 'ayer'"
              [class.text-white]="datePreset === 'ayer'"
              [class.bg-gray-100]="datePreset !== 'ayer'"
              [class.text-gray-700]="datePreset !== 'ayer'"
              class="px-3 py-1 rounded text-xs font-medium hover:bg-blue-500 hover:text-white transition">Ayer</button>
      <button (click)="setDatePreset('semana')"
              [class.bg-blue-600]="datePreset === 'semana'"
              [class.text-white]="datePreset === 'semana'"
              [class.bg-gray-100]="datePreset !== 'semana'"
              [class.text-gray-700]="datePreset !== 'semana'"
              class="px-3 py-1 rounded text-xs font-medium hover:bg-blue-500 hover:text-white transition">Esta semana</button>
      <button (click)="setDatePreset('mes')"
              [class.bg-blue-600]="datePreset === 'mes'"
              [class.text-white]="datePreset === 'mes'"
              [class.bg-gray-100]="datePreset !== 'mes'"
              [class.text-gray-700]="datePreset !== 'mes'"
              class="px-3 py-1 rounded text-xs font-medium hover:bg-blue-500 hover:text-white transition">Este mes</button>
      <button (click)="setDatePreset('all')"
              [class.bg-blue-600]="datePreset === 'all'"
              [class.text-white]="datePreset === 'all'"
              [class.bg-gray-100]="datePreset !== 'all'"
              [class.text-gray-700]="datePreset !== 'all'"
              class="px-3 py-1 rounded text-xs font-medium hover:bg-blue-500 hover:text-white transition">Todos</button>
      <span class="text-xs text-gray-400 ml-3" *ngIf="filters.from || filters.to">
        {{ filters.from || '—' }} → {{ filters.to || 'hoy' }}
      </span>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-5 gap-3">
      <select [(ngModel)]="filters.job_key" class="border rounded px-3 py-2 text-sm">
        <option value="">Todos los jobs</option>
        <option *ngFor="let j of jobs" [value]="j.job_key">{{ j.label }}</option>
      </select>
      <select [(ngModel)]="filters.status" class="border rounded px-3 py-2 text-sm">
        <option value="">Todos los estados</option>
        <option value="running">Corriendo</option>
        <option value="success">Éxito</option>
        <option value="partial">Parcial</option>
        <option value="failed">Falló</option>
        <option value="cancelled">Cancelado</option>
        <option value="queued">En cola</option>
      </select>
      <select [(ngModel)]="filters.project" class="border rounded px-3 py-2 text-sm">
        <option value="">Todos los proyectos</option>
        <option value="kredit_api">kredit_api</option>
        <option value="analysis_report_api">analysis_report_api</option>
        <option value="analysis_report_queue_api">analysis_report_queue_api</option>
      </select>
      <input type="date" [(ngModel)]="filters.from" (change)="datePreset='custom'" class="border rounded px-3 py-2 text-sm" />
      <input type="date" [(ngModel)]="filters.to" (change)="datePreset='custom'" class="border rounded px-3 py-2 text-sm" />
    </div>
    <div class="mt-3 flex gap-2 justify-end">
      <button (click)="clearFilters()" class="px-3 py-1.5 text-sm text-gray-600 hover:text-gray-800">Reset (Hoy)</button>
      <button (click)="applyFilters()" class="px-4 py-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded text-sm">Filtrar</button>
    </div>
  </div>

  <!-- Error -->
  <div *ngIf="error" class="bg-red-50 border border-red-200 text-red-700 rounded p-3 mb-4 text-sm">
    {{ error }}
  </div>

  <!-- Tabla -->
  <div class="bg-white border border-gray-200 rounded-lg overflow-hidden">
    <div class="overflow-x-auto">
      <table class="w-full text-sm">
        <thead class="bg-gray-50 text-gray-600 text-xs uppercase">
          <tr>
            <th class="px-4 py-3 text-left">Job</th>
            <th class="px-4 py-3 text-left">Estado</th>
            <th class="px-4 py-3 text-left">Trigger</th>
            <th class="px-4 py-3 text-left">Progress</th>
            <th class="px-4 py-3 text-left">Inicio</th>
            <th class="px-4 py-3 text-left">Duración</th>
            <th class="px-4 py-3 text-right">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100">
          <tr *ngIf="runs.length === 0 && !loading">
            <td colspan="7" class="px-4 py-10 text-center text-gray-500">Sin corridas registradas</td>
          </tr>
          <tr *ngFor="let run of runs" class="hover:bg-gray-50">
            <td class="px-4 py-3">
              <div class="font-medium text-gray-800">{{ run.job_label || run.job_key }}</div>
              <div class="text-xs text-gray-500">{{ run.project }}</div>
            </td>
            <td class="px-4 py-3">
              <span class="px-2 py-1 text-xs font-medium rounded-full" [ngClass]="statusBadgeClass(run.status)">
                {{ run.status }}
              </span>
              <div *ngIf="run.cancel_requested" class="text-xs text-orange-600 mt-1">⏹ cancel solicitado</div>
            </td>
            <td class="px-4 py-3 text-xs text-gray-600">
              {{ triggerBadge(run.trigger) }}
              <div *ngIf="run.triggered_by?.email" class="text-gray-500">{{ run.triggered_by.email }}</div>
            </td>
            <td class="px-4 py-3">
              <div class="flex items-center gap-2">
                <div class="w-24 bg-gray-200 rounded-full h-2 overflow-hidden">
                  <div class="h-full transition-all"
                       [style.width.%]="progressPct(run)"
                       [class.bg-blue-500]="run.status === 'running'"
                       [class.bg-green-500]="run.status === 'success'"
                       [class.bg-yellow-500]="run.status === 'partial'"
                       [class.bg-red-500]="run.status === 'failed'"
                       [class.bg-gray-400]="run.status === 'cancelled'"></div>
                </div>
                <span class="text-xs text-gray-600">{{ progressPct(run) }}%</span>
              </div>
              <div class="text-xs text-gray-500 mt-1">
                {{ progressTexto(run) }}
              </div>
            </td>
            <td class="px-4 py-3 text-xs text-gray-600">
              {{ run.started_at | date:'dd/MM/yyyy HH:mm:ss' }}
            </td>
            <td class="px-4 py-3 text-xs text-gray-600">{{ fmtDuration(run.duration_ms) }}</td>
            <td class="px-4 py-3 text-right whitespace-nowrap">
              <button (click)="openDetail(run)" class="px-3 py-1 text-xs bg-gray-100 hover:bg-gray-200 rounded mr-1">
                <i class="fas fa-eye mr-1"></i>Ver
              </button>
              <button (click)="deleteRun(run)"
                      [disabled]="deleting === run._id || (run.status === 'running' && !run.cancel_requested)"
                      [title]="run.status === 'running' && !run.cancel_requested ? 'Cancelá primero para poder eliminar' : 'Eliminar corrida'"
                      class="px-3 py-1 text-xs bg-red-50 hover:bg-red-100 text-red-700 disabled:opacity-40 disabled:cursor-not-allowed rounded">
                <i class="fas fa-trash mr-1" *ngIf="deleting !== run._id"></i>
                <i class="fas fa-spinner fa-spin mr-1" *ngIf="deleting === run._id"></i>
                Eliminar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    <div class="px-4 py-3 bg-gray-50 border-t border-gray-200 flex items-center justify-between text-sm">
      <div class="text-gray-600">
        {{ ((page - 1) * limit) + 1 }} - {{ (page * limit < total) ? (page * limit) : total }} de {{ total }}
      </div>
      <div class="flex gap-2">
        <button (click)="prevPage()" [disabled]="page === 1" class="px-3 py-1 border rounded disabled:opacity-40">←</button>
        <span class="px-3 py-1">Página {{ page }}</span>
        <button (click)="nextPage()" [disabled]="page * limit >= total" class="px-3 py-1 border rounded disabled:opacity-40">→</button>
      </div>
    </div>
  </div>
</div>
